import PropTypes from 'prop-types';
import React from 'react';
import styled, { useTheme } from 'styled-components';

import { Box, Text } from 'Components/Base';
import { getColorByProductType, PRODUCT_TYPE, PRODUCT_TYPE_TO_LABEL } from 'Util/myPath';

const Container = styled(Box)`
  border-radius: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 22px;
  border: 1px solid ${(props) => props.borderColor};
  padding: 2px ${({ theme }) => theme.space[2]}px;
`;

const ProductChip = (props) => {
  const { type, customLabel } = props;
  const theme = useTheme();
  const color = getColorByProductType(theme, type);
  const label = customLabel || PRODUCT_TYPE_TO_LABEL[type];

  return (
    <Container {...props} borderColor={color[300]} color={color[700]} backgroundColor={color[100]}>
      <Text textStyle="caption" fontWeight="600" letterSpacing="0" lineHeight="18px">
        {label}
      </Text>
    </Container>
  );
};

ProductChip.propTypes = {
  type: PropTypes.oneOf(PRODUCT_TYPE),
  customLabel: PropTypes.string,
};

ProductChip.defaultProps = {
  type: PRODUCT_TYPE.CLASSIC_COURSE,
};

export default ProductChip;
